const pdfCaptures=new WeakMap<HTMLElement,()=>Promise<Blob>>();

/** Register the viewer's full PDF.js snapshot, including its separate ink layer. */
export function registerPdfCapture(surface:HTMLElement,capture:()=>Promise<Blob>):()=>void{
 pdfCaptures.set(surface,capture);
 return()=>{if(pdfCaptures.get(surface)===capture)pdfCaptures.delete(surface);};
}

/** Capture the owned reader surface, never the desktop or another browser tab. */
export async function captureReader(surface:HTMLElement,name:string):Promise<File>{
 const pdf=surface.querySelector<HTMLElement>('.reader-content .pdf-scroll');
 if(pdf){
  const capture=pdfCaptures.get(pdf);if(!capture)throw new Error('当前 PDF 页面还在加载，请稍后截图。');
  const blob=await capture();return new File([blob],`${name.replace(/\.[^.]+$/,'')}-截图.png`,{type:'image/png'});
 }
 const source=surface.querySelector<HTMLVideoElement|HTMLImageElement>('.reader-content video,.reader-content img');
 if(!source)throw new Error('当前资料不支持截图，请打开 PDF、视频或图片。');
 const width=source instanceof HTMLVideoElement?source.videoWidth:source.naturalWidth;
 const height=source instanceof HTMLVideoElement?source.videoHeight:source.naturalHeight;
 if(!width||!height)throw new Error('画面还在加载，请稍后截图。');
 const canvas=document.createElement('canvas');canvas.width=width;canvas.height=height;
 const context=canvas.getContext('2d');if(!context)throw new Error('浏览器无法创建截图。');
 context.drawImage(source,0,0,width,height);
 const blob=await new Promise<Blob|null>(resolve=>canvas.toBlob(resolve,'image/png'));
 if(!blob)throw new Error('截图生成失败，请重试。');
 return new File([blob],`${name.replace(/\.[^.]+$/,'')}-截图.png`,{type:'image/png'});
}
